// userAgent_detection 
// -------------------
// declare variable
var userAgent;
var navigator;

// detects device mobile or desktop
if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {

    var userAgent = "handheld";

} else {

    var userAgent = "desktop";

}


// detects touch once user touch screen

window.is_touch = false;

window.addEventListener('touchstart', function onFirstTouch() {
  // we could use a class
  document.body.classList.add('is_touch');

  // or set some global variable
  window.is_touch = true;

  // we only need to know once that a human touched the screen, so we can stop listening now
  window.removeEventListener('touchstart', onFirstTouch, false);
}, false);